import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTLocation from './BOTLocation'

export default compose(
  withType({ type: 'BOTLocation' })
)(BOTLocation)
